<script setup>
// [ByChat] Item compacto de caixa, reutilizado nas visões "Compacto" (linha) e
// "Kanban" (card empilhado). Ícone + nome + canal + badge de saúde + ações. O visual
// do modo "Cards" (padrão) segue no Index.vue.
// stacked=true empilha (usado no kanban, coluna estreita) para o nome não truncar cedo.
import ChannelName from './ChannelName.vue';
import ChannelIcon from 'next/icon/ChannelIcon.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import InboxConnectionHealth from './InboxConnectionHealth.vue';

defineProps({
  inbox: { type: Object, required: true },
  isAdmin: { type: Boolean, default: false },
  stacked: { type: Boolean, default: false },
});
const emit = defineEmits(['delete']);
</script>

<template>
  <div
    class="px-2 py-2 rounded-lg hover:bg-n-alpha-1"
    :class="stacked ? 'flex flex-col gap-2' : 'flex items-center gap-3'"
  >
    <div class="flex items-center min-w-0 gap-2" :class="stacked ? 'w-full' : 'flex-1'">
      <div
        class="grid border rounded-lg size-8 shrink-0 place-items-center bg-n-alpha-3 border-n-strong"
      >
        <ChannelIcon class="size-4 text-n-slate-10" :inbox="inbox" />
      </div>
      <div class="flex flex-col flex-1 min-w-0">
        <span class="text-sm font-medium truncate text-n-slate-12">{{
          inbox.name
        }}</span>
        <ChannelName
          :channel-type="inbox.channel_type"
          :medium="inbox.medium"
          :voice-enabled="inbox.voice_enabled"
          class="text-xs truncate text-n-slate-11"
        />
      </div>
      <InboxConnectionHealth v-if="!stacked" :inbox="inbox" />
      <div v-if="!stacked" class="flex gap-1 shrink-0">
        <router-link
          :to="{ name: 'settings_inbox_show', params: { inboxId: inbox.id } }"
        >
          <Button
            v-if="isAdmin"
            v-tooltip.top="$t('INBOX_MGMT.SETTINGS')"
            icon="i-woot-settings"
            slate
            xs
            faded
          />
        </router-link>
        <Button
          v-if="isAdmin"
          v-tooltip.top="$t('INBOX_MGMT.DELETE.BUTTON_TEXT')"
          icon="i-woot-bin"
          slate
          xs
          faded
          class="hover:enabled:text-n-ruby-11 hover:enabled:bg-n-ruby-2"
          @click="emit('delete', inbox)"
        />
      </div>
    </div>

    <!-- 2ª linha (kanban empilhado): badge + ações -->
    <div
      v-if="stacked"
      class="flex items-center justify-between gap-2 ps-10"
    >
      <InboxConnectionHealth :inbox="inbox" />
      <div class="flex gap-1 shrink-0">
        <router-link
          :to="{ name: 'settings_inbox_show', params: { inboxId: inbox.id } }"
        >
          <Button
            v-if="isAdmin"
            v-tooltip.top="$t('INBOX_MGMT.SETTINGS')"
            icon="i-woot-settings"
            slate
            xs
            faded
          />
        </router-link>
        <Button
          v-if="isAdmin"
          v-tooltip.top="$t('INBOX_MGMT.DELETE.BUTTON_TEXT')"
          icon="i-woot-bin"
          slate
          xs
          faded
          class="hover:enabled:text-n-ruby-11 hover:enabled:bg-n-ruby-2"
          @click="emit('delete', inbox)"
        />
      </div>
    </div>
  </div>
</template>
